import React, { useEffect, useState, useMemo } from "react";
import Modal from 'react-modal';
import CustomizeItemSelection from "../MenuSelection/CustomizeItemSelection";
import { refPageModal } from "../../constant/constant";
interface customeType {
  open: boolean;
  onCloseModal: any;
  taxdata: any;
  menu_id: any;
}
const CustomizedModal = ({ open, onCloseModal, menu_id, taxdata, }: customeType) => {
  // for scrolling
  // Konsole.log("customizedData", customizedData, items);
  // Konsole.log('isMealItem', isMealItem)
  return (
    <Modal

      className="new-modal-react w-auto bg-white p-0 md:h-[35rem] md:!rounded-md !rounded-none  overflow-hidden"
      onRequestClose={onCloseModal}
      isOpen={open}
      closeTimeoutMS={300}
            overlayClassName="modal-overlay"

    // open={open}
    // onClose={onCloseModal}
    // center
    // classNames={{ overlay: "customOverlay", modal: "customModal", closeIcon: "modal-close", }}
    >
      <button className="new-close-btn" onClick={onCloseModal}>
        <svg className="modal-close" width="28" height="28" viewBox="0 0 36 36" data-testid="close-icon"><path d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"></path></svg>
      </button>

      <CustomizeItemSelection
        onCloseModal={onCloseModal}
        menu_id={menu_id}
        taxdata={taxdata}
        refrencePage={refPageModal}
      />

    </Modal>
  );
};
export default CustomizedModal;
